<template>
  <div id="dashboard-page">
    <v-row class="m-0 breadcrumb">
      <v-col cols="12" class="form-group">
        <h4 class="heading no-wrap"><v-icon>mdi-home</v-icon> Customer Dashboard</h4>
      </v-col>
    </v-row>
    <v-row class="m-0" style="padding: 0 12px;">
      <v-col md="4">
        <v-autocomplete
            chips
            label="Search Customers"
            v-model="selectedCustomer"
            :items="getCustomerList"
            v-on:keyup="searchCustomerByChar"
            :loading="loadingCustomer"
            variant="outlined"
            class="m-0 p-0 search-autocomplete"
            style="min-height: auto !important;"
            multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item }}</span>
            </v-chip>
            <span
                v-if="index === 1"
                class="grey--text text-caption"
            >
                    (+{{ selectedCustomer.length - 1 }} others)
                  </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col md="4">
        <v-autocomplete
            chips
            label="Search Sales Manager"
            v-model="selectedSalesManager"
            :items="getSalesManagerList"
            v-on:keyup="searchSalesManagerByChar"
            variant="outlined"
            class="m-0 p-0 search-autocomplete"
            style="min-height: auto !important;"
            multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item }}</span>
            </v-chip>
            <span
                v-if="index === 1"
                class="grey--text text-caption"
            >
                    (+{{ selectedSalesManager.length - 1 }} others)
                  </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col md="3" style="padding-right: 0;">
        <v-autocomplete
            chips
            label="Search Opportunity Owner"
            v-model="selectedOpportunityOwner"
            :items="getOpportunityOwnerList"
            v-on:keyup="searchOpportunityOwnerByChar"
            :loading="loadingOpportunityOwner"
            variant="outlined"
            class="m-0 p-0 search-autocomplete"
            style="min-height: auto !important;"
            multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index === 0">
              <span>{{ item }}</span>
            </v-chip>
            <span
                v-if="index === 1"
                class="grey--text text-caption"
            >
                    (+{{ selectedOpportunityOwner.length - 1 }} others)
                  </span>
          </template>
        </v-autocomplete>
      </v-col>
      <!----Search Button---->
      <v-col md="1" style="padding-left: 0;">
        <v-btn variant="primary" class="search-button w-100" id="myfilterSearch" ref="myCheckRef" @click="callApiData">
          <v-icon medium class="text-white">mdi-account-search</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <div class="w-100 fr" style="padding: 0 22px;">
      <v-btn class="remove-button fr"  @click.prevent="isActive = !isActive"  style="background-color: transparent !important;height: auto !important;" :disabled="disableAdvanceSearchButton">+Advance Search</v-btn>
    </div>
    <!------ Advance Search Start --->
    <div class="advance-search-div" v-if="isActive===true">
      <v-card class="p-10">
        <v-row class="m-0 p-0">
          <v-col md="3">
            <mc-multi-select
                label="Region"
                hiddenlabel
                placeholder="Select Region"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedRegion"
                name="region"
            >
              <mc-option v-for="(item, index) in getRegionList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Area"
                hiddenlabel
                placeholder="Select Area"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedArea"
                name="area"
            >
              <mc-option v-for="(item, index) in getAreaList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Trade"
                hiddenlabel
                placeholder="Select Trade"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedTrade"
                name="trade"
            >
              <mc-option v-for="(item, index) in getTradeList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Brand"
                hiddenlabel
                placeholder="Select Brand"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedBrand"
                name="brand"
            >
              <mc-option v-for="(item, index) in getBrandList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Cargo"
                hiddenlabel
                placeholder="Select Cargo"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedCargo"
                name="cargo"
            >
              <mc-option v-for="(item, index) in getCargoList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Product"
                hiddenlabel
                placeholder="Select Product"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedProduct"
                name="product"
            >
              <mc-option v-for="(item, index) in getProductList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="3">
            <mc-multi-select
                label="Sales Channel"
                hiddenlabel
                placeholder="Select Sales Channel"
                selectalllabel="Select all"
                clearalllabel="Clear all"
                summarylabel="# out of # selected"
                fit="small"
                optionswidth="trigger"
                @input="inputChanges"
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                :value.prop="selectedSalesChannel"
                name="salesChannel"
            >
              <mc-option v-for="(item, index) in getSalesChannelList" :key="index" :value="item">{{ item }}</mc-option>
            </mc-multi-select>
          </v-col>
          <v-col md="12">
            <span style="float:left; margin-top: 38px;">CEM score</span>
            <v-range-slider
                v-model="cemScore"
                max="500"
                min="-500"
                strict
                :loading="loadDropDownData"
                :disabled="disableDropDownData"
                thumb-label="always"
                style="margin-top: 35px;"
            ></v-range-slider>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <!------ Advance Search End --->
    <v-row class="m-0" style="padding: 0 12px;">
      <!---
      <v-col xl="auto">
        <mc-multi-select
            label="Sales Manager"
            hiddenlabel
            placeholder="Select Sales Manager"
            selectalllabel="Select all"
            clearalllabel="Clear all"
            summarylabel="# out of # selected"
            fit="medium"
            optionswidth="trigger"
            @input="callApiData"
            :loading="loadDropDownData"
            :disabled="disableDropDownData"
            :value.prop="selectedSalesManager"
            name="salesManager"
        >
          <mc-option v-for="(item, index) in getSalesManagerList" :key="index" :value="item">{{ item }}</mc-option>
        </mc-multi-select>
      </v-col>
      <v-col xl="auto">
        <mc-multi-select
            label="Opportunity Owner"
            hiddenlabel
            placeholder="Select Opportunity Owner"
            selectalllabel="Select all"
            clearalllabel="Clear all"
            summarylabel="# out of # selected"
            fit="medium"
            optionswidth="trigger"
            @input="callApiData"
            :loading="loadDropDownData"
            :disabled="disableDropDownData"
            :value.prop="selectedOpportunityOwner"
            name="opportunityOwner"
        >
          <mc-option v-for="(item, index) in getOpportunityOwnerList" :key="index" :value="item">{{ item }}</mc-option>
        </mc-multi-select>
      </v-col>
      -->
    </v-row>
    <v-row class="m-0">
      <v-col md="12">
        <div id="chart">
          <apexchart v-if="showCustomerGraph" type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
          <v-skeleton-loader v-else
                             loading-text="Please wait we are loading data for you"
                             class="mx-auto w-100"
                             elevation="12"
                             type="table-heading, image"
          ></v-skeleton-loader>
        </div>
      </v-col>
    </v-row>
    <v-row class="m-0">
      <v-col md="12">
        <v-card>
          <v-card-text>
            <v-card-title style="padding: 0 !important;">
              <v-row class="m-0">
                <v-col md="11">
                  <v-text-field
                      v-model="searchCustomer"
                      append-icon="mdi-magnify"
                      label="Search"
                      solo
                      dense
                      hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="1"  class="m-0 p-0 form-group" >
                  <v-tooltip left color="#42B0D5" width="50%">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon  v-bind="attrs" v-on="on" fab medium>
                        <mc-icon
                            icon="info-circle"
                            size="24"
                            color="#0CA0CE"
                        >
                        </mc-icon>
                      </v-btn>
                    </template>
                    <div class="p-10 mt-5">
                      <span><b>Recommendation :</b> Recommendation FFE from the Simulation Model</span>
                      <br>
                      <br>
                      <span><b>Existing :</b> 2025 SFDC Pipeline</span>
                      <br>
                      <br>
                      <span><b>Delta :</b> Difference between Existing and Recommendation (Existing - Recommendation)</span>
                      <br>
                      <br>
                      <span><b>Revenue :</b> Sourced from HB for 2024</span>
                      <br>
                      <br>
                      <span><b>CF % :</b> Contract fulfillment from the past 6 months</span>
                      <br>
                      <br>
                      <span><b>LnS Pipeline :</b> Inland Product SFDC pipeline for 2024 to 2025</span>
                      <br>
                      <br>
                    </div>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-title>
            <v-data-table v-if="showCustomerTable"
                          :headers="customerHeaders"
                          :items="customerItem"
                          :items-per-page="10"
                          :sort-by="['simulatedPipelineFFE']"
                          :sort-desc="[true]"
                          :search="searchCustomer"
                          class="MonthlyTable separator parent-nested-table pd-2"
                          :single-expand="singleExpand"
                          item-key="customerCode"
                          show-expand
                          id="MonthlyTable">
              <template v-slot:header>
                <thead class="text-center">
                <tr>
                  <th  class="text-center border-bottom" colspan="2"><span></span></th>
                  <th class="border-left border-bottom text-center" colspan="3"><span>Pipeline</span></th>
                  <th class="border-left border-bottom text-center" colspan="3"><span></span></th>
                  <th class="border-left border-bottom text-center" colspan="2"><span></span></th>
                </tr>
                </thead>
              </template>
              <template v-slot:[`item.data-table-expand`]="{ expand,item, isExpanded }">
                <v-btn icon
                       @click="expand(!isExpanded),tradeLevelDetails(item,isExpanded,'tradeLevel')"
                       class="v-data-table__expand-icon"
                       :class="{'v-data-table__expand-icon--active' : isExpanded}"
                ><v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.customerName`]="{ item }" >
                <span v-if="item.customerName.length < 20">
                  {{item.customerName}}({{ item.customerCode }})
                </span>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{on, attrs}">
                            <span v-bind="attrs" v-on="on">
                              {{item.customerName.substring(0,20)}}....({{ item.customerCode }})
                            </span>
                  </template>
                  <span>{{item.customerName}}({{ item.customerCode }})</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.simulatedPipelineFFE`]="{ item }" >
                <span>{{ converting(item.simulatedPipelineFFE) }}</span>
              </template>
              <template v-slot:[`item.pipelineFFE`]="{ item }" >
                <span>{{ converting(item.pipelineFFE) }}</span>
              </template>
              <template v-slot:[`item.delta`]="{ item }" >
                <mc-tag v-if="item.pipelineFFE < item.simulatedPipelineFFE" appearance="warning" fit="small"><mc-icon icon="arrow-down"></mc-icon> {{ converting(item.delta) }}</mc-tag>
                <mc-tag v-else appearance="error" fit="small"><mc-icon icon="arrow-up"></mc-icon> {{ converting(item.delta) }}</mc-tag>
              </template>
              <template v-slot:[`item.cyPerFFE`]="{ item }" >
                <span>{{ converting(item.cyPerFFE) }}</span>
              </template>
              <template v-slot:[`item.cfPerc`]="{ item }" >
                <span>{{ item.cfPerc }}</span>
              </template>
              <template v-slot:[`item.lnsPipelineFFE`]="{ item }" >
                <span>{{ converting(item.lnsPipelineFFE) }}</span>
              </template>
              <template v-slot:[`item.actions`]="{ item }" >
                <v-tooltip bottom>
                  <template v-slot:activator="{on, attrs}">
                    <v-icon small
                            v-bind="attrs"
                            v-on="on"
                            style="margin: 5px;"
                            @click="monthlyViewCustomer(item.customerName,item.customerCode,'customer')">
                      mdi-eye-outline
                    </v-icon>
                  </template>
                  <span>Monthly Split</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.sfdcLink`]="{ item }" >
                <v-tooltip bottom>
                  <template v-slot:activator="{on, attrs}">
                    <a
                        v-bind="attrs"
                        v-on="on"
                        :href="item.accId ? `https://maersk.lightning.force.com/lightning/r/Account/${item.accId}/view` : 'javascript:void(0)'"
                        :class="{ 'disabled-link': item.accId === '' }"
                        style="margin: 5px; text-decoration: none;"
                        target="_blank"
                        @click="item.accId === '' ? $event.preventDefault() : saveSFDCUserClick(item.customerName, item.customerCode, item.accId, 'sfdcLink')"
                    >
                      <v-icon small>
                        mdi-link-variant
                      </v-icon>
                    </a>
                  </template>
                  <span>Click here</span>
                </v-tooltip>
              </template>
              <template v-slot:body.append>
                <tr class="sticky-table-footer table-total-row">
                  <th scope="col" class="title text-center"></th>
                  <th scope="col" class="title text-left">Totals</th>
                  <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableCustomer('simulatedPipelineFFE')))}}</th>
                  <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableCustomer('pipelineFFE')))}}</th>
                  <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableCustomer('delta')))}}</th>
                  <th scope="col" class="title text-center">{{converting(Math.round(sumFieldFirstTableCustomer('cyPerFFE')))}}</th>
                  <th scope="col" class="title text-center"></th>
                  <th scope="col" class="title text-center"></th>
                  <th scope="col" class="title text-center"></th>
                  <th scope="col" class="title text-center"></th>
                </tr>
              </template>
              <template v-slot:expanded-item="{ headers }">
                <td :colspan="headers.length" class="p-0 position-relative childBody">
                  <v-card>
                    <v-card-title>
                      <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Search"
                          solo
                          dense
                          hide-details
                      ></v-text-field>
                    </v-card-title>
                    <v-card-text>
                      <v-data-table
                          v-if="showTrade"
                          :headers="tradeHeaders"
                          :items="tradeLevelItem"
                          :sort-by="['simulatedPipelineFFE']"
                          :sort-desc="[true]"
                          :search="search"
                          class="separator m-15 first-child-nested-table first-child-alignment"
                          :items-per-page="5"
                          id="tradeTable">
                        <template v-slot:header>
                          <thead class="text-center">
                          <tr>
                            <th  class="text-center border-bottom" colspan="2"><span></span></th>
                            <th class="border-left border-bottom text-center" colspan="3"><span>Pipeline</span></th>
                            <th class="border-left border-bottom text-center" colspan="1"><span></span></th>
                          </tr>
                          </thead>
                        </template>
                        <template v-slot:body="{items}">
                          <tbody>
                            <tr v-for="(itemVal,index) in items" :key="index" role="row">
                              <td class="text-center">{{ itemVal.tradeDirectionCode }}</td>
                              <td class="text-center">{{ itemVal.productName }}</td>
                              <td class="text-center">{{ converting(itemVal.simulatedPipelineFFE) }}</td>
                              <td class="text-center">{{ converting(itemVal.pipelineFFE) }}</td>
                              <td class="text-center">
                                  <mc-tag v-if="itemVal.pipelineFFE < itemVal.simulatedPipelineFFE" appearance="warning" fit="small"><mc-icon icon="arrow-down"></mc-icon> {{ converting(itemVal.delta) }}</mc-tag>
                                  <mc-tag v-else appearance="error" fit="small"><mc-icon icon="arrow-up"></mc-icon> {{ converting(itemVal.delta) }}</mc-tag>
                              </td>
                              <td class="text-center">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{on, attrs}">
                                    <v-icon small
                                            v-bind="attrs"
                                            v-on="on"
                                            style="margin: 5px;"
                                            @click="monthlyViewTrade(itemVal.tradeDirectionCode, itemVal.productName,'trade')">
                                      mdi-eye
                                    </v-icon>
                                  </template>
                                  <span>Monthly Split</span>
                                </v-tooltip>
                              </td>
                            </tr>
                            <tr class="sticky-table-footer table-total-row">
                              <th scope="col" class="title text-center">Totals</th>
                              <th scope="col" class="title text-center"></th>
                              <th scope="col" class="title text-center">{{ converting(Math.round(sumFieldSecondTableTrade('simulatedPipelineFFE'))) }}</th>
                              <th scope="col" class="title text-center">{{ converting(Math.round(sumFieldSecondTableTrade('pipelineFFE'))) }}</th>
                              <th scope="col" class="title text-center">{{ converting(Math.round(sumFieldSecondTableTrade('delta'))) }}</th>
                              <th scope="col" class="title text-center"></th>
                            </tr>
                          </tbody>
                        </template>
                      </v-data-table>
                      <v-skeleton-loader
                          v-else
                          loading-text="Please wait we are loading data for you"
                          height="200"
                          elevation="12"
                          type="table-heading, image"
                      ></v-skeleton-loader>
                    </v-card-text>
                  </v-card>
                </td>
              </template>
            </v-data-table>
            <v-skeleton-loader v-else
                               loading-text="Please wait we are loading data for you"
                               class="mx-auto w-100"
                               elevation="12"
                               type="table-heading, image"
            ></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <mc-modal
          :open="monthlySplitDialog"
          dimension="large"
          backdropcloseactiondisabled
          escapecloseactiondisabled
          entercloseactiondisabled
          hiddenclose
          @closed="closeMonthlySplitDialog"
          @closing="closeMonthlySplitDialog"
      >
        <mc-notification :heading="dialogHeading"
                         appearance="info"
                         class="text-center pb-2">
        </mc-notification>
        <v-data-table
                      :headers="monthlySplitHeaders"
                      :items="monthlySplitData"
                      :loading="monthlyViewTableLoading"
                      item-key="yearMonth"
                      id="tradeMonthlyTable">
          <template v-slot:[`item.yearMonth`]="{ item }" >
                  {{item.yearMonth}}
          </template>
          <template v-slot:[`item.simulatedPipelineFFE`]="{ item }" >
            <span>{{ converting(item.simulatedPipelineFFE) }}</span>
          </template>
          <template v-slot:[`item.pipelineFFE`]="{ item }" >
            <span>{{ converting(item.pipelineFFE) }}</span>
          </template>
          <template v-slot:[`item.delta`]="{ item }" >
            <mc-tag v-if="item.pipelineFFE < item.simulatedPipelineFFE" appearance="warning" fit="small"><mc-icon icon="arrow-down"></mc-icon> {{ converting(item.delta) }}</mc-tag>
            <mc-tag v-else appearance="error" fit="small"><mc-icon icon="arrow-up"></mc-icon> {{ converting(item.delta) }}</mc-tag>
          </template>
          <template v-slot:body.append>
            <tr class="sticky-table-footer table-total-row">
              <th scope="col" class="title text-center">Totals</th>
              <th scope="col" class="title text-center">{{ converting(sumFieldMonthlySplitTable('simulatedPipelineFFE')) }}</th>
              <th scope="col" class="title text-center">{{ converting(sumFieldMonthlySplitTable('pipelineFFE')) }}</th>
              <th scope="col" class="title text-center">{{ converting(sumFieldMonthlySplitTable('delta')) }}</th>
            </tr>
          </template>
        </v-data-table>
      <mc-button focusendanchor slot="secondaryAction" appearance="neutral" variant="outlined"  @click="closeMonthlySplitDialog" dialogaction="cancel">Cancel</mc-button>
      </mc-modal>
    </v-row>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import "@maersk-global/mds-components-core/mc-multi-select";
import "@maersk-global/mds-components-core/mc-option";
import "@maersk-global/mds-components-core/mc-icon";
import "@maersk-global/mds-components-core/mc-input";
import "@maersk-global/mds-components-core/mc-table";
import '@maersk-global/mds-components-core/mc-tag';

import AxiosFetchForMsal from "@/utils/axiosForMsal";
import { avActions } from "@/actions";

export default {
  name: "CustomerDashboard",
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    isActive:false,
    enableSearch: false,
    monthlySplitHeaders : [
      { text: 'Year Month', value: 'yearMonth',align: 'center',sortable: true, filterable: true },
      { text: 'Recommended Pipeline', helpText: '',desc: '', value: 'simulatedPipelineFFE', align: 'center', sortable: true },
      { text: 'Existing Pipeline', helpText: '',desc:'', value: 'pipelineFFE', align: 'center', sortable: true },
      { text: 'Delta', helpText: '',desc:'', value: 'delta', align: 'center', sortable: true },
    ],
    monthlySplitData: [],
    dialogHeading: '',
    monthlySplitDialog: false,
    loadingCustomer: false,
    loadingSalesManager: false,
    loadingOpportunityOwner: false,
    loadDropDownData: false,
    disableDropDownData: true,
    getOpportunityOwnerList: [],
    getSalesManagerList: [],
    getSalesChannelList: [],
    getProductList: [],
    getCargoList: [],
    getBrandList: [],
    getTradeList: [],
    getAreaList: [],
    getRegionList: [],
    getCustomerList: [],
    selectedCustomer: [],
    selectedRegion: [],
    selectedArea: [],
    selectedTrade: [],
    selectedBrand: [],
    selectedCargo: [],
    selectedProduct: [],
    selectedSalesChannel: [],
    selectedSalesManager: [],
    selectedOpportunityOwner: [],
    showCustomerLoading: false,
    series: [{
      name: 'Recommended Pipeline',
      data: []
    }, {
      name: 'Existing Pipeline',
      data: []
    }],
    chartOptions: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: [0,0],
        curve: ['straight','straight'],
        dashArray: [0, 0]
      },
      xaxis: {
        categories: ['202501', '202502', '202503', '202504', '202505', '202506', '202507', '202508', '202509', '202510', '202511', '202512'],
        type: 'string',
        axisBorder: {
          show: false, // Show border for the secondary x-axis
        },
      },
      colors: ['#43afd4', '#13253b'],
      yaxis: {
        min: 0, // Set min to 0 to ensure visibility of the zero line
        labels: {
          formatter: (value) => {
            if (value < 1000) {
              return value?.toString();
            } else if (value < 1000000) {
              return (value / 1000).toFixed(2) + 'K';
            } else {
              return (value / 1000000).toFixed(2) + 'M';
            }
          }
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: (value) => {
            if (value < 1000) {
              return value?.toString();
            } else if (value < 1000000) {
              return (value / 1000).toFixed(2) + 'K';
            } else {
              return (value / 1000000).toFixed(2) + 'M';
            }
          }
        }
      }
    },
    cemScore: [0,0],
    cemMax: 500,
    cemMin: -500,
    showCustomerTable : false,
    showCustomerGraph: false,
    showTrade: false,
    searchCustomer: '',
    tradeLevelItem: [],
    search: '',
    singleExpand: true,
    tradeHeaders : [
      { text: 'Trade', value: 'tradeDirectionCode',align: 'center',sortable: true, filterable: true },
      { text: 'Product', helpText: '',desc: '', value: 'productName', align: 'center', sortable: true },
      { text: 'Recommendation', helpText: '',desc:'', value: 'simulatedPipelineFFE', align: 'center', sortable: true },
      { text: 'Existing', helpText: '',desc:'', value: 'pipelineFFE', align: 'center', sortable: true },
      { text: 'Delta', helpText: '',desc: '', value: 'delta', align: 'center', sortable: true },
      { text: 'Monthly view', helpText: '',desc:'', value: 'actions', sortable: false, align: 'center', filterable: false },
    ],
    customerHeaders: [
      { text: '', value: 'data-table-expand',desc: '', align: 'center'},
      { text: 'Customer', helpText: '',desc: '', value: 'customerName', sortable: true, filterable: true, align: 'left'},
      { text: 'Recommendation', helpText: '',desc: '', value: 'simulatedPipelineFFE', sortable: true, align: 'center'},
      { text: 'Existing', helpText: '',desc:'', value: 'pipelineFFE', sortable: true, align: 'center'},
      { text: 'Delta', helpText: '',desc:'', value: 'delta', sortable: true, align: 'center'},
      { text: 'Revenue', helpText: '',desc: '', value: 'cyPerFFE', sortable: true, align: 'center'},
      { text: 'CF%', helpText: '',desc: '', value: 'cfPerc', sortable: true, align: 'center'},
      { text: 'LnS Pipeline', helpText: '',desc:'', value: 'lnsPipelineFFE', sortable: true, align: 'center'},
      { text: 'Monthly view', helpText: '',desc:'', value: 'actions', sortable: false, align: 'center', filterable: false},
      { text: 'SFDC Link', helpText: '',desc:'', value: 'sfdcLink', sortable: false, align: 'center', filterable: false},
    ],
    customerItem:[],
    customerNameSelectedTable: '',
    customerCodeSelectedTable: '',
    monthlyViewTableLoading: true,
    monthlyViewTablShow: false,
    filterData: [],
  }),
  created() {
    this.initialize();
    const retrievedData = sessionStorage.getItem("selectedFilterData");
    const parsedData = JSON.parse(retrievedData);
    this.selectedBrand = parsedData.brand;
    this.selectedSalesChannel = parsedData.salesChannel;
    this.selectedProduct = parsedData.productNames;
    this.selectedCargo = parsedData.cargo;
    this.selectedTrade = parsedData.tradeDirectionCodes;
    this.selectedArea = parsedData.areas;
    this.selectedRegion = parsedData.regions;
    this.cemMin = parsedData.cemMin;
    this.cemMax = parsedData.cemMax;
    this.cemScore = [this.cemMin,this.cemMax];
    this.getCustomerList = parsedData.customers;
    this.getSalesManagerList = parsedData.accountManagers;
    this.getOpportunityOwnerList = parsedData.accountOwners;
    this.selectedCustomer = parsedData.customers;
    this.selectedSalesManager = parsedData.accountManagers;
    this.selectedOpportunityOwner = parsedData.accountOwners;
    this.callApiData();
  },
  mounted() {
  },
  watch () {
  },
  computed: {
    disableAdvanceSearchButton(){
      if(this.disableDropDownData === false){
        return (
            this.selectedCustomer.length === 0 &&
            this.selectedSalesManager.length === 0 &&
            this.selectedOpportunityOwner.length === 0
        );
      }else {
        return true
      }
    },
  },
  methods : {
    enableAdvanceSearch(){
      if(this.selectedCustomer.length > 0){
        if(this.disableDropDownData === false){
          return false
        }
      }else if(this.selectedOpportunityOwner.length > 0){
        if(this.disableDropDownData === false){
          return false
        }
      }else if(this.selectedSalesManager.length > 0){
        if(this.disableDropDownData === false){
          return false
        }
      }
    },
    inputChanges(){
      if(event.target.label==='Region'){
        this.selectedRegion = event.target.value;
      }else if(event.target.label==='Area'){
        this.selectedArea = event.target.value;
      }else if(event.target.label==='Trade'){
        this.selectedTrade = event.target.value;
      }else if(event.target.label==='Brand'){
        this.selectedBrand = event.target.value;
      }else if(event.target.label==='Cargo'){
        this.selectedCargo = event.target.value;
      }else if(event.target.label==='Product'){
        this.selectedProduct = event.target.value;
      }else if(event.target.label==='Sales Channel'){
        this.selectedSalesChannel = event.target.value;
      }else if(event.target.label==='cemScore'){
        this.cemScore = event.target.value;
      }
    },
    closeMonthlySplitDialog(){
      this.monthlySplitData = [];
      this.monthlySplitDialog = false;
    },
    sumFieldFirstTableCustomer(key) {
      // sum data in give key (property)
      return this.customerItem.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumFieldSecondTableTrade(key) {
      // sum data in give key (property)
      return this.tradeLevelItem.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumFieldMonthlySplitTable(key) {
      // sum data in give key (property)
      return this.monthlySplitData.reduce((a, b) => a + (b[key] || 0), 0);
    },
    async monthlyViewCustomer(value, customerCode, data){
      this.dialogHeading = "Monthly split for "+ value + " (" + customerCode + ")";
      this.monthlySplitDialog = true;
      this.monthlyViewTableLoading = true;
      this.monthlyViewTablShow = false;
      console.log("value-"+value);
      console.log("data-"+data);
      const postBody = {
        "brand": this.selectedBrand,
        "productNames": this.selectedProduct,
        "tradeDirectionCodes": this.selectedTrade,
        "cargo": this.selectedCargo,
        "regions": this.selectedRegion,
        "areas":  this.selectedArea,
        "salesChannel": this.selectedSalesChannel,
        "customers": [value],
        "customerCode": [customerCode],
        "accountManagers": this.selectedSalesManager,
        "accountOwners": this.selectedOpportunityOwner,
        "cemMin": this.cemScore[0],
        "cemMax": this.cemScore[1]
      };
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const getCustomerLevelOptions = await avActions.getMonthlyPipelineDetailsList(
          postBody,
          accessTokenCheck.idToken
      );

      const getCustomerLevelResponse = await AxiosFetchForMsal(getCustomerLevelOptions);

      if (getCustomerLevelResponse.status === 200) {
        this.monthlySplitData = getCustomerLevelResponse.data;
        this.monthlyViewTableLoading = false;
        this.monthlyViewTablShow = true;
      }
    },
    async saveSFDCUserClick(value, customerCode, accountId, data){
      console.log("data-"+data);
      //window.open('https://maersk.lightning.force.com/lightning/r/Account/'+accountId+'/view', '_blank')
      const userEmail = sessionStorage.getItem("userEmail");
      const postBody = {
        "userEmail": userEmail,
        "customerCode": customerCode,
        "customerName": value,
        "accountId": accountId
      };
      console.log("postBody-"+JSON.stringify(postBody));
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const saveSFDCUserClickOptions = await avActions.saveSFDCUserClickList(
          postBody,
          accessTokenCheck.idToken
      );
      const saveSFDCUserClickResponse = await AxiosFetchForMsal(saveSFDCUserClickOptions);

      if (saveSFDCUserClickResponse.status === 200) {
        console.log("Saved SFDC User");
      }
    },
    async monthlyViewTrade(trade, product, data){
      this.dialogHeading = "Monthly split for "+ this.customerNameSelectedTable + ' (' + this.customerCodeSelectedTable + ')' + ' for ' + trade + ' Trade';
      this.monthlyViewTablShow = false;
      this.monthlySplitDialog = true;
      this.monthlyViewTableLoading = true;
      console.log("value-"+trade);
      console.log("data-"+data);
      const postBody = {
        "brand": this.selectedBrand,
        "productNames": [product],
        "tradeDirectionCodes": [trade],
        "cargo": this.selectedCargo,
        "regions": this.selectedRegion,
        "areas":  this.selectedArea,
        "salesChannel": this.selectedSalesChannel,
        "customers": [this.customerNameSelectedTable],
        "customerCode": [this.customerCodeSelectedTable],
        "accountManagers": this.selectedSalesManager,
        "accountOwners": this.selectedOpportunityOwner,
        "cemMin": this.cemScore[0],
        "cemMax": this.cemScore[1]
      };
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const getCustomerLevelOptions = await avActions.getMonthlyPipelineDetailsList(
          postBody,
          accessTokenCheck.idToken
      );

      const getCustomerLevelResponse = await AxiosFetchForMsal(getCustomerLevelOptions);

      if (getCustomerLevelResponse.status === 200) {
        this.monthlySplitData = getCustomerLevelResponse.data;
        this.monthlyViewTableLoading = false;
      }
    },
    async tradeLevelDetails(item, isExpanded, data){
      this.customerNameSelectedTable = '';
      this.customerCodeSelectedTable = '';
      this.showTrade = false;
      console.log("expanded Item-"+JSON.stringify(item));
      console.log("isExpanded-"+isExpanded);
      console.log("Data-"+data);
      const postBody = {
        "brand": this.selectedBrand,
        "productNames": this.selectedProduct,
        "tradeDirectionCodes": this.selectedTrade,
        "cargo": this.selectedCargo,
        "regions": this.selectedRegion,
        "areas":  this.selectedArea,
        "salesChannel": this.selectedSalesChannel,
        "customers": [item.customerName],
        "customerCode": [item.customerCode],
        "accountManagers": this.selectedSalesManager,
        "accountOwners": this.selectedOpportunityOwner,
        "cemMin": this.cemScore[0],
        "cemMax": this.cemScore[1]
      };
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const getTradeLevelOptions = await avActions.getTradeLevelDetailsList(
          postBody,
          accessTokenCheck.idToken
      );

      const getTradeLevelResponse = await AxiosFetchForMsal(getTradeLevelOptions);

      if (getTradeLevelResponse.status === 200) {
        this.tradeLevelItem = getTradeLevelResponse.data;
        this.customerNameSelectedTable = item.customerName;
        this.customerCodeSelectedTable = item.customerCode;
        this.showTrade = true;
      }
    },
    async searchCustomerByChar(event) {
      this.keywords=event.target.value;
      console.log(this.keywords);
      if (this.keywords.length >= 3 && event.which <= 90 && event.which >= 48) {
        this.loadingCustomer = true;
        const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
        const getCalendarListOptions = await avActions.getCustomerDetails(
            this.keywords,
            accessTokenCheck.idToken
        );
        const getCustomerDetailsResponse = await AxiosFetchForMsal(
            getCalendarListOptions
        );
        if (getCustomerDetailsResponse.status === 200) {
          if(this.selectedCustomer.length>0){
            this.arrCustomerSelected= getCustomerDetailsResponse.data.toSorted();
            this.getCustomerList = this.arrCustomerSelected.concat(this.selectedCustomer);
          }else{
            this.getCustomerList = getCustomerDetailsResponse.data.toSorted();
          }
          this.loadingCustomer = false;
        }
      }
    },
    async searchOpportunityOwnerByChar(event) {
      this.keywords=event.target.value;
      console.log(this.keywords);
      if (this.keywords.length >= 3 && event.which <= 90 && event.which >= 48) {
        this.loadingOpportunityOwner = true;
        const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
        const getOpportunityOwnerOptions = await avActions.getDistinctAccountOwnersDetails(
            this.keywords,
            accessTokenCheck.idToken
        );
        const getOpportunityOwnerResponse = await AxiosFetchForMsal(
            getOpportunityOwnerOptions
        );
        if (getOpportunityOwnerResponse.status === 200) {
          if(this.selectedOpportunityOwner.length>0){
            this.arrOpportunityOwnerSelected = getOpportunityOwnerResponse.data.toSorted();
            this.getOpportunityOwnerList = this.arrOpportunityOwnerSelected.concat(this.selectedOpportunityOwner);
          }else{
            this.getOpportunityOwnerList = getOpportunityOwnerResponse.data.toSorted();
          }
          this.loadingOpportunityOwner = false;
        }
      }
    },
    async searchSalesManagerByChar(event) {
      this.keywords=event.target.value;
      console.log(this.keywords);
      if (this.keywords.length >= 3 && event.which <= 90 && event.which >= 48) {
        this.loadingSalesManager = true;
        const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
        const getSalesManagerOptions = await avActions.getDistinctSalesManagerDetails(
            this.keywords,
            accessTokenCheck.idToken
        );
        const getSalesManagerResponse = await AxiosFetchForMsal(
            getSalesManagerOptions
        );
        if (getSalesManagerResponse.status === 200) {
          if(this.selectedSalesManager.length>0){
            this.arrSalesManagerSelected = getSalesManagerResponse.data.toSorted();
            this.getSalesManagerList = this.arrSalesManagerSelected.concat(this.selectedSalesManager);
          }else{
            this.getSalesManagerList = getSalesManagerResponse.data.toSorted();
          }
          this.loadingSalesManager = false;
        }
      }
    },
    thousandSeprator(amount) {
      if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
        return amount;
      } else {
        return amount;
      }
    },
    converting(labelValue) {
      const absValue = Math.abs(Number(labelValue));
      const sign = Math.sign(Number(labelValue)) === -1 ? '-' : ''; // Preserve the sign of the value

      const formatValue = (num) => {
        return Number.isInteger(num) ? num.toString() : num.toFixed(2);
      };

      return absValue >= 1.0e+9
          ? sign + (absValue / 1.0e+9).toFixed(0) + "B"
          : absValue >= 1.0e+6
              ? sign + (absValue / 1.0e+6).toFixed(2) + "M"
              : absValue >= 1.0e+3
                  ? sign + (absValue / 1.0e+3).toFixed(2) + "K"
                  : sign + this.thousandSeprator(formatValue(absValue));
    },
    replaceValueInArray(arr, oldValue, newValue) {
      return arr.map(item => item === oldValue ? newValue : item);
    },
    async initialize() {
      this.loadDropDownData = true;
      this.disableDropDownData = true;
      const postBody = {
        "brand": [],
        "productNames": [],
        "tradeDirectionCodes": [],
        "cargo": [],
        "regions": [],
        "areas": [],
        "salesChannel": [],
        "customers": [],
        "accountManagers": [],
        "accountOwners": [],
        "cemMin": null,
        "cemMax": null
      };
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const getDropDownListOptions = await avActions.getDropDownListDetails(
          postBody,
          accessTokenCheck.idToken
      );

      const getDropDownListResponse = await AxiosFetchForMsal(
          getDropDownListOptions
      );

      if (getDropDownListResponse.status === 200) {
        this.getBrandList = getDropDownListResponse.data.brand;
        this.getSalesChannelList = getDropDownListResponse.data.salesChannel;
        this.getProductList = getDropDownListResponse.data.productNames;
        this.getCargoList = getDropDownListResponse.data.cargo;
        this.getTradeList = getDropDownListResponse.data.tradeDirectionCodes;
        getDropDownListResponse.data.areas = this.replaceValueInArray(
            getDropDownListResponse.data.areas,
            "CENTRAL AMERICA, ANDINA, CARIBBEAN",
            "CENTRAL AMERICA | ANDINA | CARIBBEAN"
        );
        this.getAreaList = getDropDownListResponse.data.areas;
        this.getRegionList = getDropDownListResponse.data.regions;
        /*this.cemMin = getDropDownListResponse.data.cemMin;
        this.cemMax = getDropDownListResponse.data.cemMax;
        this.cemScore = [this.cemMin,this.cemMax];
         */
        this.loadDropDownData = false;
        this.disableDropDownData = false;
        //console.log("getDropDownListResponse-"+JSON.stringify(getDropDownListResponse.data));
      }
    },
    async customerTableLoad(){
      this.showCustomerTable = false;
      const postBodyData = {
        "brand": [],
        "productNames": [],
        "tradeDirectionCodes": [],
        "cargo": [],
        "regions": [],
        "areas": [],
        "salesChannel": [],
        "customers": [],
        "accountManagers": this.selectedSalesManager,
        "accountOwners": [],
        "cemMin": null,
        "cemMax": null
      };
      await this.loadChartValue(postBodyData);
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const getCustomerLevelDetailsListOptions = await avActions.getCustomerLevelDetailsList(
          postBodyData,
          accessTokenCheck.idToken
      );

      const getCustomerLevelDetailsResponse = await AxiosFetchForMsal(
          getCustomerLevelDetailsListOptions
      );

      if(getCustomerLevelDetailsResponse.status === 200){
        this.customerItem = getCustomerLevelDetailsResponse.data;
        this.showCustomerTable = true;
      }
    },
    async callApiData() {
      this.isActive = false;
      this.showCustomerTable = false;
      const postBody = {
        "brand": this.selectedBrand,
        "productNames": this.selectedProduct,
        "tradeDirectionCodes": this.selectedTrade,
        "cargo": this.selectedCargo,
        "regions": this.selectedRegion,
        "areas":  this.selectedArea,
        "salesChannel": this.selectedSalesChannel,
        "customers": this.selectedCustomer,
        "accountManagers": this.selectedSalesManager,
        "accountOwners": this.selectedOpportunityOwner,
        "cemMin": this.cemScore[0],
        "cemMax": this.cemScore[1]
      };
      await this.saveDashboardFilters(postBody);
      await this.loadChartValue(postBody);
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const getCustomerLevelDetailsListOptions = await avActions.getCustomerLevelDetailsList(
          postBody,
          accessTokenCheck.idToken
      );

      const getCustomerLevelDetailsResponse = await AxiosFetchForMsal(
          getCustomerLevelDetailsListOptions
      );

      if(getCustomerLevelDetailsResponse.status === 200){
        this.customerItem = getCustomerLevelDetailsResponse.data;
        this.showCustomerTable = true;
      }
    },
    async loadChartValue(data){
      this.showCustomerGraph=false;
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const getMonthlyPipelineDetailsListOptions = await avActions.getMonthlyPipelineDetailsList(
          data,
          accessTokenCheck.idToken
      );
      const getMonthlyPipelineDetailsResponse = await AxiosFetchForMsal(
          getMonthlyPipelineDetailsListOptions
      );
      if(getMonthlyPipelineDetailsResponse.status === 200){
        let arrCombinedYearMonth = []
        let arrRecommendedPipeline = []
        let arrExisitingPipeline = []
        this.monthlyItem = getMonthlyPipelineDetailsResponse.data
        for (let i = 0; i < this.monthlyItem.length; i++) {
          arrCombinedYearMonth.push(this.monthlyItem[i].yearMonth)
          arrRecommendedPipeline.push(this.monthlyItem[i].simulatedPipelineFFE)
          arrExisitingPipeline.push(this.monthlyItem[i].pipelineFFE)
        }

        this.series[0].data = arrRecommendedPipeline;
        this.series[1].data = arrExisitingPipeline;
        this.showCustomerGraph = true;
      }
    },
    async saveDashboardFilters(postBody){
      sessionStorage.setItem("selectedFilterData",JSON.stringify(postBody));
      const savePostBody = {
        "userEmail": sessionStorage.getItem("userEmail"),
        "crDropDownList": postBody
      }
      console.log("savePostBody-"+JSON.stringify(savePostBody));
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const saveDashboardOptions = await avActions.saveDashboardFilterList(
          savePostBody,
          accessTokenCheck.idToken
      );

      const saveDashboardResponse = await AxiosFetchForMsal(saveDashboardOptions);

      if(saveDashboardResponse.status === 200){
        console.log('saveDashboardResponse-'+saveDashboardResponse.data);
      }

    }
  }
}
</script>

<style scoped>
.border-left{
  border-left: thin solid rgba(0, 0, 0, 0.12) !important;
}
.border-bottom{
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.search-autocomplete .v-select.v-select--chips .v-select__selections{
  min-height: auto !important;
}

.customer-view-icon .mc-icon {
  display: inline-block;
  width: 100%;
}

.filter-rows .col-md-2{
  padding: 4px !important;

}

.advance-search-div{
  position: absolute;
  z-index: 2;
  top: 140px;
  right: 20px;
  width: 80%;
}

#myfilterSearch{
  background-color: #00243d;
}

.disabled-link {
  pointer-events: none;
  opacity: 0.5;
  cursor: default;
}
</style>
